//// Application Packages
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { format } from 'date-fns'
import { object, string } from 'yup'
import { translateMultiFormField } from '../../functions/field-functions'
import {
    subtractValuesAdditionalArrayForm,
    subtractValuesAdditionalConditionalForm,
    extractSubmissionForm,
} from '../../functions/form-functions'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormValidity,
    updateFormAuxiliary,
    updateFormSystem,
    deleteFormData,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components
import AddFormComponent from '../../components/navigation-components/add-form-component'
import ButtonComponent from '../../components/conditional-components/button-component'
import LoadingComponent from '../../components/simple-components/loading-component'
import NotificationComponent from '../../components/conditional-components/notification-component'
import StateSelectorComponent from '../../components/conditional-components/state-selector-component'
import CountrySelectorComponent from '../../components/conditional-components/country-selector-component'
import AdditionalOtherStateLicensesComponent from '../../components/generic-components/additional-other-state-licenses-component'

//// Carbon Components
import {
    Form,
    RadioButtonGroup,
    RadioButton,
    TextInput,
    DatePicker,
    DatePickerInput,
} from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const OtherStateLicensesForm = ({ instance }) => {
    //////// Hooks
    const dispatch = useDispatch()
    const navigate = useNavigate()

    //////// State
    const [loading, setLoading] = useState(false)
    const [notification, setNotification] = useState({})

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']
    const submit_route = settingsData?.['form']?.['submit_route']
    const fields = settingsData?.['form']?.['fields']
    const profession = settingsData?.['form']?.['profession']
    const max_form_iterations =
        settingsData?.['application']?.['max_form_iterations']
    const conditions = settingsData?.['form']?.['conditions']
    const clnt_cde = settingsData?.['category']?.['clnt_cde']
    const xact_cde = settingsData?.['category']?.['xact_cde']

    //////// Search Params

    //////// Methods

    // This Moment Now
    const now = format(new Date(), 'MM/dd/yyyy').toString()

    // Generate Validation Schema
    const generateSchema = async (auxAddtForms) => {
        try {
            const dynamic = {}
            if (auxAddtForms?.length > 0) {
                dynamic.addtObjs = [
                    {
                        OTHR_ST_LIC: '',
                        RSD66: '',
                        RSD169: '',
                        RSD67: '',
                        RSD368: '',
                        RSD171: '',
                        RSD172: '',
                        RSD170: '',
                        ORGLICST: '',
                    },
                ]
                dynamic.addtFilds = [
                    {
                        OTHR_ST_LIC: false,
                        OTHR_ST_LICErrMsg: '',
                        RSD66: false,
                        RSD66ErrMsg: '',
                        RSD169: false,
                        RSD169ErrMsg: '',
                        RSD67: false,
                        RSD67ErrMsg: '',
                        RSD368: false,
                        RSD368ErrMsg: '',
                        RSD171: false,
                        RSD171ErrMsg: '',
                        RSD172: false,
                        RSD172ErrMsg: '',
                        RSD170: false,
                        RSD170ErrMsg: '',
                        ORGLICST: false,
                        ORGLICSTErrMsg: '',
                    },
                ]
                dynamic.addtObjs[0] = {
                    ...dynamic.addtObjs[0],
                    OTHR_ST_LIC: '',
                    RSD66: '',
                    RSD169: '',
                    RSD67: '',
                    RSD368: '',
                    RSD171: '',
                    RSD172: '',
                    RSD170: '',
                    ORGLICST: '',
                }
                dynamic.addtFilds[0] = {
                    ...dynamic.addtFilds[0],
                    OTHR_ST_LIC: '',
                    OTHR_ST_LICErrMsg: '',
                    RSD66: '',
                    RSD66ErrMsg: '',
                    RSD169: '',
                    RSD169ErrMsg: '',
                    RSD67: '',
                    RSD67ErrMsg: '',
                    RSD368: '',
                    RSD368ErrMsg: '',
                    RSD171: '',
                    RSD171ErrMsg: '',
                    RSD172: '',
                    RSD172ErrMsg: '',
                    RSD170: '',
                    RSD170ErrMsg: '',
                    ORGLICST: '',
                    ORGLICSTErrMsg: '',
                }
                await auxAddtForms.forEach(async (el) => {
                    dynamic.addtObjs.push({
                        [`RSD66` + el]: '',
                        [`RSD169` + el]: '',
                        [`RSD67` + el]: '',
                        [`RSD368` + el]: '',
                        [`RSD171` + el]: '',
                        [`RSD172` + el]: '',
                        [`RSD170` + el]: '',
                        [`ORGLICST` + el]: '',
                    })
                    dynamic.addtFilds.push({
                        [`RSD66` + el]: '',
                        [`RSD66` + el]: false,
                        [`RSD169` + el]: '',
                        [`RSD169` + el]: false,
                        [`RSD67` + el]: '',
                        [`RSD67` + el]: false,
                        [`RSD368` + el]: '',
                        [`RSD368` + el]: false,
                        [`RSD171` + el]: '',
                        [`RSD171` + el]: false,
                        [`RSD172` + el]: '',
                        [`RSD172` + el]: false,
                        [`RSD170` + el]: '',
                        [`RSD170` + el]: false,
                        [`ORGLICST` + el]: '',
                        [`ORGLICST` + el]: false,
                    })
                })
                dynamic.addtObjsSchema = {}
                if (dynamic?.addtObjs?.length > 0) {
                    dynamic.addtObjs.forEach(async (el) => {
                        dynamic.addtObjsSchema = {
                            ...dynamic.addtObjsSchema,
                            ...el,
                        }
                    })
                }
                dynamic.addtFildsSchema = {}
                if (dynamic?.addtFilds?.length > 0) {
                    dynamic.addtFilds.forEach(async (el) => {
                        dynamic.addtFildsSchema = {
                            ...dynamic.addtFildsSchema,
                            ...el,
                        }
                    })
                }
                dynamic.addtObjsSchemaKeys = Object?.keys(
                    dynamic.addtObjsSchema
                )
                dynamic.addtFildsSchemaKeys = Object?.keys(
                    dynamic.addtFildsSchema
                )
                dynamic.addtSchema = {}
                if (dynamic?.addtObjsSchemaKeys?.length > 0) {
                    dynamic.addtObjsSchemaKeys.forEach(async (el) => {
                        if (el?.includes('RSD66')) {
                            dynamic.addtSchema = {
                                ...dynamic.addtSchema,
                                [el]: string()
                                    .min(0)
                                    .max(60)
                                    .required(
                                        'This field is required to be entered or selected.'
                                    ),
                            }
                        } else if (el?.includes('RSD169')) {
                            dynamic.addtSchema = {
                                ...dynamic.addtSchema,
                                [el]: string()
                                    .min(0)
                                    .max(20)
                                    .required(
                                        'This field is required to be entered or selected.'
                                    ),
                            }
                        } else if (el?.includes('RSD170')) {
                            dynamic.addtSchema = {
                                ...dynamic.addtSchema,
                                [el]: string()
                                    .min(0)
                                    .max(40)
                                    .required(
                                        'This field is required to be entered or selected.'
                                    ),
                            }
                        } else {
                            dynamic.addtSchema = {
                                ...dynamic.addtSchema,
                                [el]: string().required(
                                    'This field is required to be entered or selected.'
                                ),
                            }
                        }
                    })
                }
                dynamic.addtValid = {}
                if (dynamic?.addtFildsSchemaKeys?.length > 0) {
                    dynamic.addtFildsSchemaKeys.forEach(async (el) => {
                        if (el?.includes('ErrMsg')) {
                            dynamic.addtValid = {
                                ...dynamic.addtValid,
                                [el]: '',
                            }
                        } else {
                            dynamic.addtValid = {
                                ...dynamic.addtValid,
                                [el]: false,
                            }
                        }
                    })
                }
            }
            return dynamic
        } catch (error) {
            console.warn('Generate Schema Error:', error)
            return null
        }
    }

    // Validate Data Submission
    const validation = async (submit) => {
        // Validate Form Submission Data Against Schema
        try {
            // Schema Object
            const schema = {}
            if (
                formsData?.[digital_name]?.values?.OTHR_ST_LIC === undefined ||
                formsData?.[digital_name]?.values?.OTHR_ST_LIC === 'N'
            ) {
                schema.yup = object({
                    OTHR_ST_LIC: string().required(
                        'This field is required to be entered or selected.'
                    ),
                })
                schema.valid = {
                    OTHR_ST_LIC: false,
                    OTHR_ST_LICErrMsg: '',
                }
            } else if (
                formsData?.[digital_name]?.values?.OTHR_ST_LIC === 'Y' &&
                formsData[digital_name].auxiliary.addtForms?.length === 0
            ) {
                schema.yup = object({
                    OTHR_ST_LIC: string().required(
                        'This field is required to be entered or selected.'
                    ),
                    RSD66: string()
                        .min(0)
                        .max(60)
                        .required(
                            'This field is required to be entered or selected.'
                        ),
                    RSD169: string()
                        .min(0)
                        .max(20)
                        .required(
                            'This field is required to be entered or selected.'
                        ),
                    RSD67: string().required(
                        'This field is required to be entered or selected.'
                    ),
                    RSD368: string().required(
                        'This field is required to be entered or selected.'
                    ),
                    RSD171: string().required(
                        'This field is required to be entered or selected.'
                    ),
                    RSD172: string().required(
                        'This field is required to be entered or selected.'
                    ),
                    RSD170: string()
                        .min(0)
                        .max(40)
                        .required(
                            'This field is required to be entered or selected.'
                        ),
                    ORGLICST: string().required(
                        'This field is required to be entered or selected.'
                    ),
                })
                schema.valid = {
                    OTHR_ST_LIC: false,
                    OTHR_ST_LICErrMsg: '',
                    RSD66: false,
                    RSD66ErrMsg: '',
                    RSD169: false,
                    RSD169ErrMsg: '',
                    RSD67: false,
                    RSD67ErrMsg: '',
                    RSD368: false,
                    RSD368ErrMsg: '',
                    RSD171: false,
                    RSD171ErrMsg: '',
                    RSD172: false,
                    RSD172ErrMsg: '',
                    RSD170: false,
                    RSD170ErrMsg: '',
                    ORGLICST: false,
                    ORGLICSTErrMsg: '',
                }
            } else if (
                formsData?.[digital_name]?.values?.OTHR_ST_LIC === 'Y' &&
                formsData[digital_name].auxiliary.addtForms?.length > 0
            ) {
                const addtForms = formsData[digital_name].auxiliary.addtForms
                const { addtSchema, addtValid } = await generateSchema(
                    addtForms
                )
                schema.yup = object().shape({ ...addtSchema })
                schema.valid = addtValid
            }
            await schema.yup.validate(
                { ...submit },
                { strict: true, abortEarly: false }
            )
            dispatch(
                updateFormValidity({
                    digital_name: digital_name,
                    errors: {},
                })
            )
            return true
        } catch (err) {
            const errors = {}
            if (err?.inner?.length > 0) {
                await err.inner.forEach(async (el) => {
                    if (el?.path) {
                        errors[el?.path] = true
                        if (el?.errors?.length > 0) {
                            const errName = el?.path + 'ErrMsg'
                            const errMsg = el?.errors?.join(' ')
                            const tran = translateMultiFormField(
                                fields,
                                max_form_iterations,
                                el?.path
                            )
                            if (tran) {
                                const tranErrMsg = await errMsg.replaceAll(
                                    el?.path,
                                    tran
                                )
                                errors[errName] = tranErrMsg
                            } else {
                                errors[errName] = el?.errors?.join(' ')
                            }
                        }
                    }
                })
            }

            dispatch(
                updateFormValidity({
                    digital_name: digital_name,
                    errors: errors,
                })
            )
            return false
        }
    }

    // Re-Validate Data Submission
    const revalidation = async (event_name) => {
        try {
            // Update Validation State
            if (digital_name && event_name) {
                dispatch(
                    updateFormValidity({
                        digital_name: digital_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        } catch (error) {
            console.warn('Revalidation Error:', error)
            return null
        }
    }

    //////// Functional Methods

    // Handle Removal Of Other State License Component/s
    const handleSubtractAdditionalOtherStateLicensesComponent = async (e) => {
        try {
            if (e?.target?.name) {
                const addtForms = [
                    ...formsData[digital_name].auxiliary.addtForms,
                ]
                const subt = parseInt(e.target.name)
                const index = addtForms?.indexOf(subt)
                if (index > -1) {
                    addtForms.splice(index, 1)
                    dispatch(
                        updateFormAuxiliary({
                            digital_name: digital_name,
                            auxiliary: {
                                addtForms: addtForms,
                            },
                        })
                    )
                    const values = subtractValuesAdditionalArrayForm(
                        fields,
                        max_form_iterations,
                        formsData?.[digital_name]?.values,
                        index
                    )
                    if (values) {
                        dispatch(
                            deleteFormData({
                                digital_name: digital_name,
                            })
                        )
                        dispatch(
                            updateFormData({
                                digital_name: digital_name,
                                values: values,
                            })
                        )
                    }
                }
            }
        } catch (error) {
            console.warn(
                'Handle Subtract Additional Other State Licenses Component Error:',
                error
            )
            return null
        }
    }

    // Handle Removal Of Additional Other State License Component/s
    const handleSubtractAdditionalConditionalComponent = (e) => {
        try {
            if (e?.target?.name && e?.target?.value) {
                const values = subtractValuesAdditionalConditionalForm(
                    conditions,
                    formsData?.[digital_name]?.values,
                    e?.target?.name,
                    e?.target?.value
                )
                if (values) {
                    dispatch(
                        deleteFormData({
                            digital_name: digital_name,
                        })
                    )
                    dispatch(
                        updateFormAuxiliary({
                            digital_name: digital_name,
                            auxiliary: {
                                addtForms: [],
                            },
                        })
                    )
                    dispatch(
                        updateFormData({
                            digital_name: digital_name,
                            values: values,
                        })
                    )
                }
            }
        } catch (error) {
            console.warn(
                'Handle Subtract Additional Other State Licenses Component Error:',
                error
            )
            return null
        }
    }

    // Handle Data Of All Fields + DatePicker (ID)
    const handleData = (e, id) => {
        if (e?.target?.name && e?.target?.value) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: {
                        [e.target.name]: e.target.value,
                    },
                })
            )
            revalidation(e.target.name)
        } else if (e?.target?.name) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: { [e.target.name]: '' },
                })
            )
            revalidation(e.target.name)
        } else if (e?.length > 0 && id) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: {
                        [id]: format(new Date(e?.[0]), 'MM/dd/yyyy'),
                    },
                })
            )
            revalidation(id)
        }
        //// Start Watson Assistant Journey

        if (
            xact_cde === '1010' &&
            clnt_cde === '1701' &&
            e?.target?.name === 'OTHR_ST_LIC' &&
            e?.target?.value === 'Y'
        ) {
            instance.tours.startTour(
                'Registered Nurse Examination Other State Licenses Yes Tour'
            )
        } else if (
            xact_cde === '1010' &&
            clnt_cde === '1702' &&
            e?.target?.name === 'OTHR_ST_LIC' &&
            e?.target?.value === 'Y'
        ) {
            instance.tours.startTour(
                'Licensed Practical Nurse Examination Other State Licenses Yes Tour'
            )
        } else {
            instance.tours.endTour()
        }

        //// End Watson Assistant Journey
    }

    // Handle Form Submission
    const handleSubmit = async () => {
        try {
            console.info('Other State Licenses: Submitted')

            setLoading(true)

            // Extract Form Data From Redux
            const submit = await extractSubmissionForm(digital_name, formsData)

            // Validate Form Submission Data
            const valid = await validation(submit)

            // Check If Form Data Is Valid
            if (valid) {
                console.info('Other State Licenses: Passed Valid')

                dispatch(
                    updateFormSystem({
                        digital_name: digital_name,
                        system: { valid: true },
                    })
                )
                setLoading(false)
                setNotification({
                    type: 'inline',
                    visible: false,
                    kind: '',
                    title: '',
                    subtitle: '',
                })

                // Navigate To Next Form
                navigate(submit_route ? submit_route : '/')
            } else {
                console.info('Other State Licenses: Failed Valid')

                dispatch(
                    updateFormSystem({
                        digital_name: digital_name,
                        system: { valid: false },
                    })
                )
                setLoading(false)
                setNotification({
                    type: 'inline',
                    visible: true,
                    kind: 'error',
                    title: 'Form Errors:',
                    subtitle:
                        'There are errors on the form (such as missing required info). Please scroll up and update the fields with red messages.',
                })

                console.log(
                    'Other State Licenses Failed Valid: There are errors on the form (such as missing required info). Please scroll up and update the fields with red messages.'
                )
            }
        } catch (error) {
            console.warn('Handle Submit Error:', error)
            return null
        }
    }

    // Handle Keyboard Enter As Submit (Method)
    const handleKeyDown = async (event) => {
        try {
            if (event?.key === 'Enter') {
                await handleSubmit()
            }
        } catch (error) {
            console.warn('Handle Down Key Error:', error)
            return null
        }
    }

    //////// Memoization

    //////// Effects/Side Effects
    // Reload Watson Assistant Journey on Reload
    useEffect(() => {
        if (instance?.tours) {
            instance.tours.endTour()
        }
        return () => {}
    }, [instance])

    //////////////// Render & Return
    if (loading) {
        return (
            <>
                <Form
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                    onSubmit={handleSubmit}
                >
                    <LoadingComponent />
                </Form>
            </>
        )
    } else if (
        formsData?.[digital_name]?.values?.OTHR_ST_LIC === undefined ||
        formsData?.[digital_name]?.values?.OTHR_ST_LIC === 'N'
    ) {
        return (
            <>
                <Form
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                    onSubmit={handleSubmit}
                >
                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.OTHR_ST_LIC
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.OTHR_ST_LIC
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.OTHR_ST_LIC
                        }
                        legendText={`Do you hold, or have you ever held a license to practice ${profession} or any other health-related license(s)?`}
                        name="OTHR_ST_LIC"
                        invalid={formsData?.[digital_name]?.errors?.OTHR_ST_LIC}
                        invalidText={
                            formsData?.[digital_name]?.errors?.OTHR_ST_LICErrMsg
                        }
                    >
                        <RadioButton
                            id="OTHR_ST_LICYes"
                            name="OTHR_ST_LICYes"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={(e) => {
                                handleData(e)
                                handleSubtractAdditionalConditionalComponent(e)
                            }}
                        />
                        <RadioButton
                            id="OTHR_ST_LICNo"
                            name="OTHR_ST_LICNo"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={(e) => {
                                handleData(e)
                                handleSubtractAdditionalConditionalComponent(e)
                            }}
                        />
                    </RadioButtonGroup>

                    <NotificationComponent notification={notification} />

                    <div className="button-group">
                        <div className="button-group-item">
                            <ButtonComponent
                                click={handleSubmit}
                                title="Save Progress"
                            />
                        </div>
                    </div>
                </Form>
            </>
        )
    } else if (
        formsData?.[digital_name]?.values?.OTHR_ST_LIC === 'Y' &&
        formsData[digital_name].auxiliary.addtForms?.length === 0
    ) {
        return (
            <>
                <Form onSubmit={handleSubmit}>
                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.OTHR_ST_LIC
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.OTHR_ST_LIC
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.OTHR_ST_LIC
                        }
                        legendText={`Do you hold, or have you ever held a license to practice ${profession} or any other health-related license(s)?`}
                        name="OTHR_ST_LIC"
                        invalid={formsData?.[digital_name]?.errors?.OTHR_ST_LIC}
                        invalidText={
                            formsData?.[digital_name]?.errors?.OTHR_ST_LICErrMsg
                        }
                    >
                        <RadioButton
                            id="OTHR_ST_LICYes"
                            name="OTHR_ST_LICYes"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={(e) => {
                                handleData(e)
                                handleSubtractAdditionalConditionalComponent(e)
                            }}
                        />
                        <RadioButton
                            id="OTHR_ST_LICNo"
                            name="OTHR_ST_LICNo"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={(e) => {
                                handleData(e)
                                handleSubtractAdditionalConditionalComponent(e)
                            }}
                        />
                    </RadioButtonGroup>

                    <p>
                        List all health-related licenses (active, inactive, or
                        lapsed).
                    </p>

                    <TextInput
                        className="required"
                        labelText="License Type:"
                        id="RSD66"
                        name="RSD66"
                        placeholder=""
                        value={formsData?.[digital_name]?.values?.RSD66}
                        maxLength="60"
                        type="text"
                        onChange={handleData}
                        invalid={formsData?.[digital_name]?.errors?.RSD66}
                        invalidText={
                            formsData?.[digital_name]?.errors?.RSD66ErrMsg
                        }
                    />

                    <TextInput
                        className="required"
                        labelText="License #:"
                        id="RSD169"
                        name="RSD169"
                        placeholder=""
                        value={formsData?.[digital_name]?.values?.RSD169}
                        maxLength="20"
                        type="text"
                        onChange={handleData}
                        invalid={formsData?.[digital_name]?.errors?.RSD169}
                        invalidText={
                            formsData?.[digital_name]?.errors?.RSD169ErrMsg
                        }
                    />

                    <CountrySelectorComponent
                        digital_name={digital_name}
                        value_key="RSD368"
                        state_value_key="RSD67"
                        county_value_key=""
                    />

                    <StateSelectorComponent
                        digital_name={digital_name}
                        value_key="RSD67"
                        country={formsData?.[digital_name]?.values?.RSD368}
                    />

                    <DatePicker
                        dateFormat="m/d/Y"
                        datePickerType="single"
                        onChange={(e) => handleData(e, 'RSD171')}
                        onClose={(e) => handleData(e, 'RSD171')}
                        value={formsData?.[digital_name]?.values?.RSD171}
                        maxDate={now}
                    >
                        <DatePickerInput
                            className="required"
                            labelText="Original Date Issued:"
                            id="RSD171"
                            name="RSD171"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            invalid={formsData?.[digital_name]?.errors?.RSD171}
                            invalidText={
                                formsData?.[digital_name]?.errors?.RSD171ErrMsg
                            }
                        />
                    </DatePicker>

                    <DatePicker
                        dateFormat="m/d/Y"
                        datePickerType="single"
                        onChange={(e) => handleData(e, 'RSD172')}
                        onClose={(e) => handleData(e, 'RSD172')}
                        value={formsData?.[digital_name]?.values?.RSD172}
                        minDate={formsData?.[digital_name]?.values?.RSD171}
                    >
                        <DatePickerInput
                            className="required"
                            labelText="Expiration Date:"
                            id="RSD172"
                            name="RSD172"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            invalid={formsData?.[digital_name]?.errors?.RSD172}
                            invalidText={
                                formsData?.[digital_name]?.errors?.RSD172ErrMsg
                            }
                        />
                    </DatePicker>

                    <TextInput
                        className="required"
                        labelText="Status of License:"
                        id="RSD170"
                        name="RSD170"
                        placeholder=""
                        value={formsData?.[digital_name]?.values?.RSD170}
                        maxLength="50"
                        type="text"
                        onChange={handleData}
                        invalid={formsData?.[digital_name]?.errors?.RSD170}
                        invalidText={
                            formsData?.[digital_name]?.errors?.RSD170ErrMsg
                        }
                    />

                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.ORGLICST
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.ORGLICST
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.ORGLICST
                        }
                        legendText={`Select "Yes," if this is your Original State of Licensure for this license type.`}
                        name="ORGLICST"
                        invalid={formsData?.[digital_name]?.errors?.ORGLICST}
                        invalidText={
                            formsData?.[digital_name]?.errors?.ORGLICSTErrMsg
                        }
                    >
                        <RadioButton
                            id="ORGLICSTYes"
                            name="ORGLICSTYes"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="ORGLICSTNo"
                            name="ORGLICSTNo"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>

                    <AddFormComponent />

                    <p>
                        <strong>The board requires verification</strong> of
                        licensure from your original state of licensure (exam
                        state) and from a state where you have a current active
                        license. Only one verification is required if your
                        original state is current and active.{' '}
                        <strong>
                            Office staff will attempt to complete verifications
                            online
                        </strong>
                        . If unavailable online or if the online verification
                        lacks sufficient detail, you will be required to request
                        an official verification.
                    </p>

                    <NotificationComponent notification={notification} />

                    <div className="button-group">
                        <div className="button-group-item">
                            <ButtonComponent
                                click={handleSubmit}
                                title="Save Progress"
                            />
                        </div>
                    </div>
                </Form>
            </>
        )
    } else if (
        formsData?.[digital_name]?.values?.OTHR_ST_LIC === 'Y' &&
        formsData[digital_name].auxiliary.addtForms?.length > 0
    ) {
        return (
            <>
                <Form onSubmit={handleSubmit}>
                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.OTHR_ST_LIC
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.OTHR_ST_LIC
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.OTHR_ST_LIC
                        }
                        legendText={`Do you hold, or have you ever held a license to practice ${profession} or any other health-related license(s)?`}
                        name="OTHR_ST_LIC"
                        invalid={formsData?.[digital_name]?.errors?.OTHR_ST_LIC}
                        invalidText={
                            formsData?.[digital_name]?.errors?.OTHR_ST_LICErrMsg
                        }
                    >
                        <RadioButton
                            id="OTHR_ST_LICYes"
                            name="OTHR_ST_LICYes"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={(e) => {
                                handleData(e)
                                handleSubtractAdditionalConditionalComponent(e)
                            }}
                        />
                        <RadioButton
                            id="OTHR_ST_LICNo"
                            name="OTHR_ST_LICNo"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={(e) => {
                                handleData(e)
                                handleSubtractAdditionalConditionalComponent(e)
                            }}
                        />
                    </RadioButtonGroup>

                    <p>
                        List all health-related licenses (active, inactive, or
                        lapsed).
                    </p>

                    <TextInput
                        className="required"
                        labelText="License Type:"
                        id="RSD66"
                        name="RSD66"
                        placeholder=""
                        value={formsData?.[digital_name]?.values?.RSD66}
                        maxLength="60"
                        type="text"
                        onChange={handleData}
                        invalid={formsData?.[digital_name]?.errors?.RSD66}
                        invalidText={
                            formsData?.[digital_name]?.errors?.RSD66ErrMsg
                        }
                    />

                    <TextInput
                        className="required"
                        labelText="License #:"
                        id="RSD169"
                        name="RSD169"
                        placeholder=""
                        value={formsData?.[digital_name]?.values?.RSD169}
                        maxLength="20"
                        type="text"
                        onChange={handleData}
                        invalid={formsData?.[digital_name]?.errors?.RSD169}
                        invalidText={
                            formsData?.[digital_name]?.errors?.RSD169ErrMsg
                        }
                    />

                    <CountrySelectorComponent
                        digital_name={digital_name}
                        value_key="RSD368"
                        state_value_key="RSD67"
                        county_value_key=""
                    />

                    <StateSelectorComponent
                        digital_name={digital_name}
                        value_key="RSD67"
                        country={formsData?.[digital_name]?.values?.RSD368}
                    />

                    <DatePicker
                        dateFormat="m/d/Y"
                        datePickerType="single"
                        onChange={(e) => handleData(e, 'RSD171')}
                        onClose={(e) => handleData(e, 'RSD171')}
                        value={formsData?.[digital_name]?.values?.RSD171}
                        maxDate={now}
                    >
                        <DatePickerInput
                            className="required"
                            labelText="Original Date Issued:"
                            id="RSD171"
                            name="RSD171"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            invalid={formsData?.[digital_name]?.errors?.RSD171}
                            invalidText={
                                formsData?.[digital_name]?.errors?.RSD171ErrMsg
                            }
                        />
                    </DatePicker>

                    <DatePicker
                        dateFormat="m/d/Y"
                        datePickerType="single"
                        onChange={(e) => handleData(e, 'RSD172')}
                        onClose={(e) => handleData(e, 'RSD172')}
                        value={formsData?.[digital_name]?.values?.RSD172}
                        minDate={formsData?.[digital_name]?.values?.RSD171}
                    >
                        <DatePickerInput
                            className="required"
                            labelText="Expiration Date:"
                            id="RSD172"
                            name="RSD172"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            invalid={formsData?.[digital_name]?.errors?.RSD172}
                            invalidText={
                                formsData?.[digital_name]?.errors?.RSD172ErrMsg
                            }
                        />
                    </DatePicker>

                    <TextInput
                        className="required"
                        labelText="Status of License:"
                        id="RSD170"
                        name="RSD170"
                        placeholder=""
                        value={formsData?.[digital_name]?.values?.RSD170}
                        maxLength="50"
                        type="text"
                        onChange={handleData}
                        invalid={formsData?.[digital_name]?.errors?.RSD170}
                        invalidText={
                            formsData?.[digital_name]?.errors?.RSD170ErrMsg
                        }
                    />

                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.ORGLICST
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.ORGLICST
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.ORGLICST
                        }
                        legendText={`Select "Yes," if this is your Original State of Licensure for this license type.`}
                        name="ORGLICST"
                        invalid={formsData?.[digital_name]?.errors?.ORGLICST}
                        invalidText={
                            formsData?.[digital_name]?.errors?.ORGLICSTErrMsg
                        }
                    >
                        <RadioButton
                            id="ORGLICSTYes"
                            name="ORGLICSTYes"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="ORGLICSTNo"
                            name="ORGLICSTNo"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>

                    {formsData[digital_name].auxiliary.addtForms.map((el) => (
                        <AdditionalOtherStateLicensesComponent
                            key={el}
                            number={el}
                            handleData={handleData}
                            handleSubtractAdditionalOtherStateLicensesComponent={
                                handleSubtractAdditionalOtherStateLicensesComponent
                            }
                        />
                    ))}

                    <AddFormComponent />

                    <p>
                        <strong>The board requires verification</strong> of
                        licensure from your original state of licensure (exam
                        state) and from a state where you have a current active
                        license. Only one verification is required if your
                        original state is current and active.{' '}
                        <strong>
                            Office staff will attempt to complete verifications
                            online
                        </strong>
                        . If unavailable online or if the online verification
                        lacks sufficient detail, you will be required to request
                        an official verification.
                    </p>

                    <NotificationComponent notification={notification} />

                    <div className="button-group">
                        <div className="button-group-item">
                            <ButtonComponent
                                click={handleSubmit}
                                title="Save Progress"
                            />
                        </div>
                    </div>
                </Form>
            </>
        )
    }
}

export default OtherStateLicensesForm
